import { Button, Grid } from "@mui/material";
import React from "react";
import { HelpDialog } from "./HelpDialog";
import { OrganizationDataRecipientDto } from "../../../common/service/server/dto/OrganizationDataRecipientDto";
import { DataRecipientLogo } from "../DataRecipientLogo";
import { ExternalLink } from "../../../common/components/ExternalLink";
import validator from "validator";

interface Props {
  recipients: {
    recipient: OrganizationDataRecipientDto;
    email: string;
  }[];
  open: boolean;
  onClose: () => void;
}

export const EmailRecipientsDialog: React.FC<Props> = ({ recipients, open, onClose }) => {
  return (
    <HelpDialog
      open={open}
      onClose={onClose}
      title={"Notification Recipients"}
      actions={
        <Button variant="contained" color="primary" onClick={onClose}>
          Close
        </Button>
      }
      disableBackdropClick={true}
      className="intro-help-dialog"
      maxWidth="md"
    >
      <DialogBody recipients={recipients} />
    </HelpDialog>
  );
};

const DialogBody = ({ recipients }) => {
  return (
    <Grid container spacing={2}>
      {recipients.map(({ recipient, email }) => (
        <Grid key={recipient.vendorId} item xs={12} sm={6} className="d-flex align-items-center">
          <div className="p-md fill d-flex align-items-center flex--justify-start">
            <DataRecipientLogo dataRecipient={recipient} size={32} className="mr-mdlg" />

            <div className="w-256">
              <div className="text-t3 text-weight-bold line-height-normal">{recipient.name}</div>
              {recipient.gdprSccVendorReviewContacted ? (
                <div className="text-t2 color-green-500">(Email sent)</div>
              ) : (
                <>
                  {Boolean(email) && validator.isEmail(email) ? (
                    <div className="text-t2">
                      <ExternalLink href={`mailto:${email}`}>{email}</ExternalLink>
                    </div>
                  ) : (
                    <div className="text-t2 color-red-600">
                      {email.trim().length > 0
                        ? `Invalid email: ${email}`
                        : "(Email field is empty)"}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
